import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import participantsSlice from "./reducers/participantsSlice";
import userSlice from "./reducers/userSlice";
import administratorsSlice from "./reducers/administratorsSlice";
import questionSlice from "./reducers/questionSlice";
import responseSlice from "./reducers/responseSlice";
import appSlice from "./reducers/appSlice";
import studySlice from "./reducers/studySlice";
import organisationSlice from "./reducers/organisationSlice";
import featuresSlice from "./reducers/featuresSlice";
import questionTranslationSlice from "./reducers/questionTranslationSlice";
import analysisSlice from "./reducers/analysisSlice";

export const store = configureStore({
  reducer: {
    user: userSlice,
    participants: participantsSlice,
    administrators: administratorsSlice,
    question: questionSlice,
    questionTranslation: questionTranslationSlice,
    response: responseSlice,
    study: studySlice,
    app: appSlice,
    organisation: organisationSlice,
    features: featuresSlice,
    analysis: analysisSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
